<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>Edit and Send AI Suggested Response</v-card-title>

        <v-card-text>

             <v-textarea
                label="Message"
                v-model="question"
                auto-grow
                rows="1"
                readonly
            />

            <v-textarea
                label="Reply"
                v-model="text"
                autofocus
                auto-grow
                rows="1"
            >
                <span
                    slot="append-outer"
                >
                    <v-icon
                        style="align-self: flex-end; margin-bottom: 3px; margin-right: 2px"
                        v-on:click="onClickEmoji"
                    >
                        mdi-emoticon-outline
                    </v-icon>
                </span>
            </v-textarea>

            <b>Important Note: </b>This response has been generated by Artificial Intelligence (AI). The AI has been trained to craft a convincing response. To do so, it is sometimes necessary for the AI to <b>make up facts</b> about prices, dates, availability, etc. Before sending, please review and edit for accuracy. 

            <v-checkbox
                label="I have reviewed the message and confirmed that it is accurate and appropriate to send."
                v-model="ack"
            />

        </v-card-text>

        

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel" 
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onSend"
                :disabled="!ack"
            >
            Send
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            question: null,
            text: null,
            ack: false,
        }
    },

    methods: {

        showDialog(question, text)
        {
            this.question = question;
            this.text = text;
            this.ack = false;
            this.dialog = true;
        },

        onSend()
        {
            this.dialog = false;
            this.$emit('send',this.text);
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickEmoji()
        {
            this.$rc.simplePickEmoji((value) => { 
                if ( this.text == null || this.text.trim().length == 0 ) { this.text = value; return; }
                    this.text += ' '+value;
            })
        }

    },
}
</script>

<style lang="scss" scoped>
</style>